import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { sprintf } from 'sprintf-js';

import { environment } from '../../environments/environment';
import { BaseService } from './base.service';

@Injectable()
export class AttendeeAnswerAnonymousService extends BaseService {

  constructor(
    protected http: HttpClient,
  ) {
    super(http, `${environment.apiBaseUrl}/companies/%(company_id)s/events/%(event_id)s/attendee_answer_anonymouses`);
  }

  listSubmissions(urlParams: any = {}, apiParams: any = {}): Observable<any[]> {
    const url = sprintf(`${environment.apiBaseUrl}/companies/%(company_id)s/events/%(event_id)s/attendee_answer_anonymouses`, urlParams);
    return this.http.get<any[]>(url, {
      params: this.toHttpParams(apiParams)
    });
  }

  getAnswers(urlParams: any = {}, apiParams: any = {}): Observable<any> {
    const url = sprintf(
      `${environment.apiBaseUrl}/companies/%(company_id)s/events/%(event_id)s/attendee_answer_anonymouses/%(anonymous_uuid)s`,
      urlParams
    );
    return this.http.get<any>(url, {
      params: this.toHttpParams(apiParams)
    });
  }

  listAll(urlParams: any = {}, apiParams: any = {}): Observable<any> {
    const url = sprintf(`${environment.apiBaseUrl}/companies/%(company_id)s/events/%(event_id)s/attendee_answer_anonymouses/all`, urlParams);
    return this.http.get<any>(url, {
      params: this.toHttpParams(apiParams)
    });
  }

  deleteSubmission(urlParams: any = {}): Observable<any> {
    const url = sprintf(
      `${environment.apiBaseUrl}/companies/%(company_id)s/events/%(event_id)s/attendee_answer_anonymouses/%(anonymous_uuid)s`,
      urlParams
    );
    return this.http.delete<any>(url);
  }
}
